import { useTheme } from "@/theme/ThemeProvider";
import { Stack } from "expo-router";
import { StatusBar } from "expo-status-bar";
import { Platform, View } from "react-native";

/** Kein Auth-Redirect. Die einzige Schranke sitzt im Root-Layout. */
export default function PublicLayout() {
  const { theme } = useTheme();

  return (
    <View
      style={{ flex: 1 }}
      {...(Platform.OS === "web" ? { dataSet: { fcShell: "1" } } : {})}
    >
      <StatusBar style="dark" backgroundColor={theme.color.bg} />
      <Stack screenOptions={{ headerShown: false }} />
    </View>
  );
}
